// Pantalla de login (se muestra en App.jsx cuando no hay sesión activa).
import { useState } from "react";
import { motion } from "framer-motion";
import { Eye, EyeOff, Loader } from "lucide-react";
import { api } from "../api";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const { login } = useAuth();
  const [form, setForm]     = useState({ username: "", password: "" });
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState(null);

  const set = (k) => (e) => setForm(p => ({ ...p, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.username || !form.password) return;
    setLoading(true);
    setError(null);
    try {
      const res = await api.login(form);
      if (res.error) throw new Error(res.error);
      login(res.token, res.user);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-bg">
      <motion.div className="login-card"
        initial={{ opacity: 0, y: 32, scale: 0.96 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ type: "spring", stiffness: 300, damping: 26, mass: 0.8 }}>
        <div className="login-brand">
          <img src="/logo-horizontal.jpg" alt="RIESST-GO" className="login-logo" />
          <p className="login-sub">Sistema de Gestión Documental SST</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <label>Usuario</label>
            <input
              className="form-input"
              type="text"
              placeholder="Ingresa tu usuario"
              value={form.username}
              onChange={set("username")}
              autoFocus
              autoComplete="username"
            />
          </div>

          <div className="form-row">
            <label>Contraseña</label>
            <div style={{ position: "relative" }}>
              <input
                className="form-input"
                type={showPass ? "text" : "password"}
                placeholder="Ingresa tu contraseña"
                value={form.password}
                onChange={set("password")}
                autoComplete="current-password"
                style={{ paddingRight: 40 }}
              />
              <button type="button" onClick={() => setShowPass(p => !p)}
                style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "var(--text-muted)" }}>
                {showPass ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
          </div>

          {error && (
            <div className="login-error">{error}</div>
          )}

          <button type="submit" className="btn-primary login-btn" disabled={!form.username || !form.password || loading}>
            {loading ? <><Loader size={16} className="spin" /> Ingresando...</> : "Iniciar sesión"}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
